import axios from "axios";
import { getBase64FromUrl } from "../../hooks/helpers";
import { createAsyncThunk } from "@reduxjs/toolkit";
import GetQrLink from "./getQrLink";
export { GetQrLink };

const getFormData = (data) => {
  const formData = new FormData();
  data.imgLogo[0]?.file && formData.append(`logo`, data.imgLogo[0].file);
  formData.append(`title`, data.title);
  formData.append(`description`, data.description);
  formData.append(`background_color`, data.colors[0]);
  formData.append(`link_background_color`, data.colors[1]);
  formData.append(`link_text_color`, data.colors[2]);
  formData.append(`qrTitle`, data.qrTitle);
  formData.append(`isLogoRound`, data.isLogoRound ? 1 : 0);
  if (data.socials.length) {
    formData.append(`socials`, JSON.stringify(data.socials));
  }
  if (data.links.length) {
    formData.append(`links`, JSON.stringify(data.links));
  }
  return formData;
};

export const LinkListAPI = async (data) => {
  const response = await axios({
    url: "/qr-code/link-list",
    method: "POST",
    data: getFormData(data),
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const LinkListEditAPI = async (data) => {
  const response = await axios({
    url: `/qr-code/ajax/edit/${data.id}`,
    method: "POST",
    data: getFormData(data),
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const FetchLinkListData = createAsyncThunk(
  "FetchLinkListData",
  async (id) => {
    try {
      const response = await axios.get(`/link-list/${id}`);
      let base64Logo = "";
      let links = [];
      const logoImg = response.data[0]?.entryFilesLogo?.path;
      const isLogoRound = response.data[0]?.entryFilesLogo?.isLogoRound;
      if (!!logoImg) {
        base64Logo = await getBase64FromUrl(logoImg);
      }
      if (response.data[0]?.entryItemListLinks) {
        links = await Promise.all(
          response.data[0].entryItemListLinks.map(async (item) => {
            let base64LinkImg = "";
            if (item.entryFilesListLinks?.path) {
              base64LinkImg = await getBase64FromUrl(
                item.entryFilesListLinks.path
              );
            }
            return {
              id: item.id,
              url: item.linksUrl,
              text: item.linksText,
              img: base64LinkImg,
            };
          })
        );
      }
      return {
        ...response.data[0],
        logo: base64Logo,
        links,
        isLogoRound,
        qrTitle: response.data.qrTitle,
        adsCategories: response.data.adsCategories,
      };
    } catch (err) {
      throw new Error(err.response.status);
    }
  }
);
